import React, {useEffect, useState} from 'react';
import UtahHeaderConfig from "./UtahHeaderConfig";
import utahHeaderLoaded from "./utahHeaderLoaded";
import UtahHeaderContext, {utahHeaderContextValue} from "./UtahHeaderContext";
import PropTypes from "prop-types";

const propTypes = {
	children: PropTypes.any,
	onHeaderChange: PropTypes.func,
	utahHeaderVersion: PropTypes.string,
	utahHeaderUrl: PropTypes.string,
};
const defaultProps = {
	children: null,
	onHeaderChange: null,
	utahHeaderUrl: null,
	utahHeaderVersion: 'latest',
};

const UtahHeader = (
	{
		children,
		onHeaderChange,
		utahHeaderVersion,
		utahHeaderUrl
	}
) => {
	const [utahHeaderVar, setUtahHeader] = useState(window.utahHeader);

	// load utah header
	useEffect(() => {
		// add header bundle with current version (not latest)
		const script = document.createElement('script');
		const scriptUrl = utahHeaderUrl ?
			utahHeaderUrl :
			`https://cdn.utah.gov/utah-header/${utahHeaderVersion ? utahHeaderVersion.replace(/\./ig, '_') : 'latest'}/utahHeader.bundle.js`;
		script.setAttribute('src', scriptUrl);
		document.head.appendChild(script);

		utahHeaderLoaded.then(() => {
			setUtahHeader(window.utahHeader);
			utahHeaderContextValue.utahHeader = window.utahHeader;
			window.utahHeader.setConfig(UtahHeaderConfig());
		});
	}, []);

	// onHeaderChange
	useEffect(() => {
		onHeaderChange && onHeaderChange(utahHeaderVar);
	}, [utahHeaderVar]);

	return (
		<UtahHeaderContext.Provider value={utahHeaderContextValue}>
			{children}
		</UtahHeaderContext.Provider>
	);
};

UtahHeader.propTypes = propTypes;
UtahHeader.defaultProps = defaultProps;

export const withContext = Component => <UtahHeaderContext.consumer>{context => <Component context={context}/>}</UtahHeaderContext.consumer>;
export {utahHeaderLoaded};
export default UtahHeader;
